import React, { useEffect, useState } from "react";
import {
  getFirestore,
  collection,
  getDocs,
  doc,
  updateDoc,
  deleteDoc,
} from "firebase/firestore";
import "./AdminBonusManager.css";

const AdminBonusManager = () => {
  const db = getFirestore();

  const [username, setUsername] = useState("");
  const [userDocId, setUserDocId] = useState(null);
  const [bonuses, setBonuses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [editData, setEditData] = useState({});

  // =========================
  // SEARCH USER + BONUS
  // =========================
  const searchUser = async () => {
    if (!username) return alert("Weka username");

    setLoading(true);
    setBonuses([]);
    setUserDocId(null);

    try {
      const usersSnap = await getDocs(collection(db, "users"));
      const userDoc = usersSnap.docs.find(
        (d) => d.data().username === username
      );

      if (!userDoc) {
        alert("User hapatikani");
        setLoading(false);
        return;
      }

      setUserDocId(userDoc.id);

      const bonusSnap = await getDocs(
        collection(db, "users", userDoc.id, "bonusHistory")
      );

      const list = bonusSnap.docs.map((d) => ({
        id: d.id,
        ...d.data(),
      }));

      setBonuses(list);
    } catch (err) {
      console.error(err);
      alert("Error wakati wa kutafuta user");
    }

    setLoading(false);
  };

  // =========================
  // START EDIT
  // =========================
  const startEdit = (bonus) => {
    setEditingId(bonus.id);
    setEditData({
      amount: bonus.amount,
      type: bonus.type,
      source: bonus.source || "",
    });
  };

  // =========================
  // SAVE EDIT
  // =========================
  const saveEdit = async (bonusId) => {
    try {
      const bonusRef = doc(
        db,
        "users",
        userDocId,
        "bonusHistory",
        bonusId
      );

      await updateDoc(bonusRef, {
        ...editData,
        editedBy: "ADMIN",
        editedAt: new Date(),
      });

      setBonuses((prev) =>
        prev.map((b) =>
          b.id === bonusId ? { ...b, ...editData } : b
        )
      );

      setEditingId(null);
    } catch (err) {
      console.error(err);
      alert("Imeshindikana ku-edit bonus");
    }
  };

  // =========================
  // DELETE BONUS
  // =========================
  const deleteBonus = async (bonusId) => {
    if (!window.confirm("Una uhakika wa kufuta bonus hii?")) return;

    try {
      await deleteDoc(
        doc(db, "users", userDocId, "bonusHistory", bonusId)
      );

      setBonuses((prev) =>
        prev.filter((b) => b.id !== bonusId)
      );
    } catch (err) {
      console.error(err);
      alert("Imeshindikana kufuta bonus");
    }
  };

  return (
    <div className="admin-bonus-container">
      <h2>Admin Bonus Manager</h2>

      <div className="search-box">
        <input
          type="text"
          placeholder="Tafuta username..."
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <button onClick={searchUser}>SEARCH</button>
      </div>

      {loading && <p>Loading...</p>}

      {bonuses.map((b) => (
        <div className="admin-bonus-card" key={b.id}>
          {editingId === b.id ? (
            <>
              <input
                type="number"
                value={editData.amount}
                onChange={(e) =>
                  setEditData({
                    ...editData,
                    amount: Number(e.target.value),
                  })
                }
              />

              <input
                type="text"
                value={editData.type}
                onChange={(e) =>
                  setEditData({
                    ...editData,
                    type: e.target.value,
                  })
                }
              />

              <input
                type="text"
                value={editData.source}
                onChange={(e) =>
                  setEditData({
                    ...editData,
                    source: e.target.value,
                  })
                }
              />

              <button onClick={() => saveEdit(b.id)}>
                SAVE
              </button>
              <button
                className="cancel"
                onClick={() => setEditingId(null)}
              >
                CANCEL
              </button>
            </>
          ) : (
            <>
              <p>
                <strong>Amount:</strong>{" "}
                {Number(b.amount).toLocaleString()}
              </p>
              <p>
                <strong>Type:</strong> {b.type}
              </p>
              <p>
                <strong>Source:</strong>{" "}
                {b.source || "-"}
              </p>

              <div className="admin-actions">
                <button onClick={() => startEdit(b)}>
                  EDIT
                </button>
                <button
                  className="delete"
                  onClick={() => deleteBonus(b.id)}
                >
                  DELETE
                </button>
              </div>
            </>
          )}
        </div>
      ))}
    </div>
  );
};

export default AdminBonusManager;